import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Icon, Segment, Step } from "semantic-ui-react";

import { config } from "../../config";
import { AuthStore } from "../../stores/auth-store";
import { AccountRequirements } from "../../stores/models/user";
import { EditorPane } from "../common/editor-pane";
import { AccountSetup } from "./forms/account-setup";
import { OptIn } from "./forms/opt-in";
import { SetPassword } from "./forms/set-password";
import { Terms } from "./forms/terms";

declare var toastr: any;

interface IAuthViewProps{
	authStore?: AuthStore;
}

interface IAuthViewState{
	activeStep: StepState;
}

enum StepState{
	Password = 0,
	Setup = 1,
	Terms = 2,
	Done  = 3
}

@inject("authStore") @observer
export class AuthView extends React.Component<IAuthViewProps, IAuthViewState>{
	constructor(props, state){
		super(props, state);

		this.state = {
			"activeStep": StepState.Password
		};

		this.handlePasswordNext = this.handlePasswordNext.bind(this);
		this.handleSetupNext = this.handleSetupNext.bind(this);
		this.handleTermsNext = this.handleTermsNext.bind(this);
	}

	componentDidMount(){
		this.setStateFromRequirements(this.props);
	}

	componentWillReceiveProps(nextProps: IAuthViewProps){
		this.setStateFromRequirements(nextProps);
	}

	setStateFromRequirements(props: IAuthViewProps){
		if(props.authStore.hasRequirement(AccountRequirements.PasswordChangeRequired)){
			this.setState({"activeStep": StepState.Password});
		}
		else if(props.authStore.hasRequirement(AccountRequirements.SetupRequired)){
			this.setState({"activeStep": StepState.Setup});
		}
		else if(props.authStore.hasRequirement(AccountRequirements.TermsRequired) || props.authStore.hasRequirement(AccountRequirements.MessageOptInRequired) || props.authStore.hasRequirement(AccountRequirements.ReAcceptTerms)){
			this.setState({"activeStep": StepState.Terms});
		}
	}

	handlePasswordNext(){
		this.setState({"activeStep": StepState.Setup});
		this.props.authStore.removeRequirement(AccountRequirements.PasswordChangeRequired);
	}

	handleSetupNext(){
		this.setState({"activeStep": StepState.Terms});
		this.props.authStore.removeRequirement(AccountRequirements.SetupRequired);
	}


	handleTermsNext(){
		this.setState({"activeStep": StepState.Done}, () => {
			location.hash = "";
			location.search = "";
			location.reload();
		});
		location.reload();
	}

	render(){
		const { authStore } = this.props;
		const { activeStep } = this.state;

		console.log(activeStep);

		if(authStore.requirements > 0 && authStore.loggedIn){
			return (
				<div style={{"marginRight": "150px", "marginLeft": "150px", "marginTop": "150px"}}>
					<Step.Group attached="top">
						{this.props.authStore.hasRequirement(AccountRequirements.PasswordChangeRequired) &&
							<Step active={activeStep == StepState.Password}>
								<Icon name="lock" />
								<Step.Content>
									<Step.Title>
										Password Change
									</Step.Title>
									<Step.Description>
										Create a new password
									</Step.Description>
								</Step.Content>
							</Step>
						}
						{this.props.authStore.hasRequirement(AccountRequirements.SetupRequired) &&
							<Step active={activeStep == StepState.Setup}>
								<Icon name="id badge" />
								<Step.Content>
									<Step.Title>
										Account Setup
									</Step.Title>
									<Step.Description>
										Add information to you account to help us serve you better
									</Step.Description>
								</Step.Content>
							</Step>
						}
						{(this.props.authStore.hasRequirement(AccountRequirements.TermsRequired) || this.props.authStore.hasRequirement(AccountRequirements.MessageOptInRequired) || this.props.authStore.hasRequirement(AccountRequirements.ReAcceptTerms)) &&
							<Step active={activeStep == StepState.Terms}>
								<Icon name="university" />
								<Step.Content>
									<Step.Title>
										Terms and Conditions
									</Step.Title>
									<Step.Description>
										EULA and notification opt-in
									</Step.Description>
								</Step.Content>
							</Step>
						}
					</Step.Group>
					<Segment attached textAlign="center">
						{activeStep == StepState.Password && <SetPassword onNext={this.handlePasswordNext} />}
						{activeStep == StepState.Setup && <AccountSetup onNext={this.handleSetupNext} />}
						{activeStep == StepState.Terms && <Terms onNext={this.handleTermsNext} />}
						{activeStep == StepState.Done && <div><h2>Setup Complete</h2><br/>If you are not automatically redirected to JUMP in 5 seconds please click <a href={config.apiServer}>here</a>.</div>}
					</Segment>
				</div>
			);
		}
		else{
			let redirectQS = window.location.href;

			var queryString = window.location.search;
			if(!queryString){
				queryString = window.location.hash;
				if(queryString.split("?").length === 2){
					queryString = queryString.split("?")[1];
				}
			}

			if(queryString){
				var searchParams = new URLSearchParams(queryString);
				if(searchParams.get("redirect")){
					redirectQS = searchParams.get("redirect");
				}
			}

			window.location.replace(`${config.apiServer}login-redirect?noJSTCheck=1&redirect=${encodeURIComponent(redirectQS)}`);
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/auth-view.tsx